import axios from 'api/axios'
import handleAxiosError from 'utils/handleAxiosError'

export interface ResetBody {
	password: string
}

/**
 * Type Definition for Set new password
 */

export interface SetNewPassword {
	message: string
	statusCode: number
}

const ResetPassword = async (body: ResetBody) => {
	try {
		const { data } = await axios.post<SetNewPassword>(
			'management/set-password',
			body
		)
		return data
	} catch (error: any) {
		handleAxiosError(error)
		throw error
	}
}

export default ResetPassword
